<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';
import ScheduledMessageDialog from './ScheduledMessageDialog.vue';
import { useConfig } from 'dashboard/composables/useConfig';
import { useInbox } from 'dashboard/composables/useInbox';

const { t } = useI18n();
const { isEnterprise } = useConfig();
const { isAWhatsAppCloudChannel } = useInbox();

const dialogRef = ref(null);
const isVisible = computed(() => isEnterprise && isAWhatsAppCloudChannel.value);

const openDialog = () => dialogRef.value?.open();
</script>

<template>
  <div class="contents">
    <template v-if="isVisible">
      <Button
        v-tooltip.top-end="t('CONVERSATION.SCHEDULED_MESSAGE.ACTION')"
        :aria-label="t('CONVERSATION.SCHEDULED_MESSAGE.ACTION')"
        icon="i-ph-calendar"
        slate
        faded
        sm
        @click="openDialog"
      />
      <ScheduledMessageDialog ref="dialogRef" />
    </template>
  </div>
</template>
